import React, { FC, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import StyledButton from 'components/Button';
import { BookingOverlay, BookingSummaryContainer, BookingSummarySlot } from '../../style';
//import { BookingSummaryContainer } from './style';
import { useRecoilValue, useRecoilState } from 'recoil';
import { selectedRooms } from 'states/CheckOutStates/atoms';
import {
  dateRangeState,
  guestQuantityState,
  roomQuantityState,
} from 'states/SearchBarStates/atoms';
import { dateDiff } from 'utils/util';
import moment from 'moment';
// import { EditIcon } from 'assets/icons';
import { HST_RATE, MAT_RATE } from 'constants/constant';
import { ReactNode } from 'react';
import { useMobileBookingSummary } from 'customHooks/useMobileBookingSummary';

const debug = false;


const BookingSummary: FC = () => {

  const history = useHistory()




  const [persistSelectedRooms] = useRecoilState(selectedRooms);
  const [guestQuantity] = useRecoilState(guestQuantityState);
  const [roomQuantity] = useRecoilState(roomQuantityState);
  const dateRange = useRecoilValue(dateRangeState);
  const nights = dateDiff(new Date(dateRange[0]), new Date(dateRange[1]))
  
  const [summaryText, setSummaryText] = useState<ReactNode>(null);
  const { isOverlay, panelRef, handleRef, slotRef, detailsRef, toggle, close } = useMobileBookingSummary();


  useEffect (()=> {

    if (debug) {
      console.log ("persistSelectedRooms step 2:", persistSelectedRooms);
    }

    setSummaryText(
      <>
        {persistSelectedRooms.name}
        <br />- {persistSelectedRooms.bed}
        {persistSelectedRooms.hasWindows
          ? " w/ window"
          : persistSelectedRooms.name === "Bishop Inside"
          ? " no/ window"
          : " w/ skylight"}
        {" " + roomQuantity * nights + " @ $" + persistSelectedRooms.pricePerNight}
      </>
    );

  }, [persistSelectedRooms, nights, roomQuantity])
  
  
  const totalPrice = (persistSelectedRooms.pricePerNight ?? 0) * roomQuantity * nights;
  const MAT = totalPrice * MAT_RATE;

  const HST = (totalPrice + MAT) * HST_RATE;
  const total = totalPrice + MAT + HST;

  const handleNext = () => {
    //history.push('/addOnOptions');
    history.push('/check-out');
  }

  return (
    <>
    <BookingOverlay
    className={isOverlay ? 'visible' : ''}
    onClick={close}
    />
    <BookingSummarySlot ref={slotRef} className={isOverlay ? 'reserved' : ''} aria-hidden="true" />
    <BookingSummaryContainer ref={panelRef} className={`mobileFlowSummary ${isOverlay ? 'summaryOverlay' : ''}`}>
    <div
        className="swipeToHide"
        ref={handleRef}
        role="button"
        tabIndex={0}
        aria-expanded={isOverlay}
        onClick={toggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        }}
      >
      {isOverlay ? 'Tap here to hide details' : 'Tap here to show details'}
        <div className="swipeToHideHr"></div>
      </div>
      <div className="bookingMobileContentDetails" ref={detailsRef}>
        <div className="titleStep2 flowSummaryTitle">
          <span className='text'>Your booking summary</span>
          {/* <span
            className='editTrip'
            onClick={() => {
              history.push(`/search?checkInDate=${dateRange[0]}&checkOutDate=${dateRange[1]}&guestQuantity=${guestQuantity}&roomQuantity=${roomQuantity}`);
            }}
          >
            <EditIcon className='editIcon'/>
            Edit trip
          </span> */}
        </div>
        <table cellPadding={0} cellSpacing={0} border={0} className="datesTable">
          <tr>
            <td className='hdr' width="100%">DATES</td>
            <td className="hdr">ROOMS / GUESTS</td>
          </tr>
          <tr>
            <td  className="data">
            {moment(dateRange[0]).format('MMM Do YYYY')}&nbsp;-&nbsp;
            {moment(dateRange[1]).format('MMM Do YYYY')}
            &nbsp;&nbsp;&nbsp;
            <span
            className='editTrip'
            onClick={() => {
              history.push(`/search?checkInDate=${dateRange[0]}&checkOutDate=${dateRange[1]}&guestQuantity=${guestQuantity}&roomQuantity=${roomQuantity}`);
            }}
          >
            Edit
          </span>
            </td>
            <td className="data dataRt">{roomQuantity}/{guestQuantity}
            &nbsp;&nbsp;&nbsp;
            <span
            className='editTrip'
            onClick={() => {
              history.push(`/search?checkInDate=${dateRange[0]}&checkOutDate=${dateRange[1]}&guestQuantity=${guestQuantity}&roomQuantity=${roomQuantity}`);
            }}
          >
            Edit
          </span>
            </td>
          </tr>
        </table>
        <div className="separator"></div>
        <div className="booking">BREAKDOWN</div>
        <table cellPadding={0} cellSpacing={0} border={0} className="breakdownTable">
          <tr>
            <td>{roomQuantity} {roomQuantity === 1 ? 'Room' : 'Rooms'} – {nights} {nights === 1 ? 'Night' : 'Nights'}</td>
            <td></td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">{summaryText}</span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${totalPrice.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">Municipal Accommodation Tax (6%)</span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${MAT.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="line">
              <span className="label">HST (13%)</span>
              <span className="dots"></span>
            </td>
            <td className="price">
            ${HST.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
          <tr>
            <td className="total">TOTAL</td>
            <td className="total price">
            ${total.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </td>
          </tr>
        </table>
        {/* <div className="priceDetails">
          <span className='text'>{persistSelectedRooms.name?.toUpperCase()}</span>
          <span className='price'>{` CAD ${persistSelectedRooms.pricePerNight?.toFixed(2)} / night`}</span>
        </div> */}
        </div>
                <div className="controls">
        <div className="mobileTotals">
          <div className="closedContent">
          <div className="mobileTotalsTotal">Total <span>
            ${total.toLocaleString('en-CA', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
            </span></div>
          <div className="mobileTotalsGuests">Guests/Rooms <span>{guestQuantity}/{roomQuantity}</span></div>
          </div>
        </div>
          <div className="controlsButton">
        <StyledButton
          className="nextButton"
          height="48px"
          padding ="0 24px"
          fontSize={16}
          onClick={handleNext}
        >
          Next Step
        </StyledButton>
        </div>
        </div>
        {/* <div className="controls">
        <StyledButton
          className="nextButton"
          height="48px"
          margin='42px 0 10px 0'
          padding ="0 24px"
          fontSize={18}
          onClick={handleNext}
        >
          Next Step
        </StyledButton>
        </div> */}
      
    </BookingSummaryContainer>
    </>
  )
}

export default BookingSummary